import axios from "axios";

document.querySelectorAll('[data-load-more]').forEach(item => item.addEventListener('click', function () {
    item.setAttribute('disabled', 'disabled');

    const posts_inner_el = document.querySelector(item.getAttribute('data-posts_inner_el'));
    let current_page_number = parseInt(item.getAttribute('data-current'));

    axios.get(api_settings.ajax_url, {
        params: {
            nonce: api_settings.nonce,
            action: 'load_more_posts',
            post_type: item.getAttribute('data-post_type'),
            current: current_page_number,
            per_page: item.getAttribute('data-per_page'),
            s: item.getAttribute('data-s'),
            term_id: item.getAttribute('data-term_id'),
            taxonomy: item.getAttribute('data-taxonomy'),
        }
    })
        .then(function (response) {
            const data = response.data.data;

            if (response.data.success) {
                current_page_number+=1;
                item.setAttribute('data-current', current_page_number);

                posts_inner_el.insertAdjacentHTML('beforeend', data.posts_html);

                if (current_page_number >= data.total_pages) {
                    item.style.display = 'none';
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            item.removeAttribute('disabled');
        });
}));


document.querySelectorAll('[data-filter]').forEach(item => item.addEventListener('click', function () {
    item.setAttribute('disabled', 'disabled');

    let is_active = false;
    const more_el = document.querySelector(item.getAttribute('data-more_el'));

    if (item.classList.contains('active')) {
        item.classList.remove('active');
        is_active = true;
    }
    else {
        document.querySelectorAll('[data-filter]').forEach(subitem => subitem.classList.remove('active'));
        item.classList.add('active');
    }

    const term_id = is_active ? '' : item.getAttribute('data-term-id');
    const taxonomy = is_active ? '' : item.getAttribute('data-taxonomy');
    const posts_inner_el = document.querySelector(item.getAttribute('data-posts_inner_el'));
    const posts_inner_el_2 = document.querySelector(item.getAttribute('data-posts_inner_el_2'));
    const is_team = item.getAttribute('data-team');

    more_el?.setAttribute('data-term_id', term_id);

    axios.get(api_settings.ajax_url, {
        params: {
            nonce: api_settings.nonce,
            action: 'load_more_posts',
            post_type: item.getAttribute('data-post_type'),
            current: 0,
            per_page: item.getAttribute('data-per_page'),
            s: '',
            term_id,
            taxonomy,
            is_team,
        }
    })
        .then(function (response) {
            const data = response.data.data;

            if (response.data.success) {
                posts_inner_el.innerHTML = data.posts_html;

                if (posts_inner_el_2) {
                    posts_inner_el_2.innerHTML = data.posts_html_2;
                    const swiper_el = posts_inner_el_2.closest('.swiper');
                    swiper_el.swiper.update();
                }

                more_el?.setAttribute('data-current', 1);

                if (more_el) {
                    if (data.total_pages === 1) {
                        more_el.style.display = 'none';
                    }
                    else {
                        more_el.style.display = 'flex';
                    }
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            item.removeAttribute('disabled');
        });
}));